<template lang="pug">
.social-media-list.flex.items-center.flex-wrap-reverse.z-10
  template(v-if="showSocialList")
    template(v-for="socialItem in socialList")
      button(v-if="socialItem.actions === 'COPY'", class="clipboard-social-media", type="button", :data-clipboard-text="socialItem.link", :data-field="socialItem.name")
        img.w-full.h-full(:src="getSocialIcon(socialItem)", :alt="socialItem.name")
      a.block.text-center(v-else-if="socialItem.icon_type === 'custom'", :href="socialItem.link", class="", rel="noopener noreferrer", target="_blank")
        img.w-full.h-full(v-if="socialItem.image", :src="socialItem.image", :alt="socialItem.name")
        span.socialmedia-link.text-primary-text(v-else) {{ socialItem.name }}
      a.block.text-center(v-else, :href="socialItem.link", class="", rel="noopener noreferrer", target="_blank")
        img.w-full.h-full(:src="getSocialIcon(socialItem)", :alt="socialItem.name")
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from '#imports'
import ClipboardJS from 'clipboard'

const props = defineProps({
  isWebView: {
    type: Boolean,
    default: false,
  },
  socialList: {
    type: Array,
    default: () => [],
  },
  showSocialList: {
    type: Boolean,
    default: false,
  },
})

const { $toast } = useNuxtApp()
const { t } = useI18n()
const { getSocialIconUrl } = useCdnAssets()

const clipboard = ref(null)

const getSocialIcon = (socialItem) => {
  // 優先使用自訂圖片
  if (socialItem.image) {
    return socialItem.image
  }

  // 使用 CDN URL，圖片直接從 CDN 載入，不經過 Vite 打包
  // 檔案不存在時瀏覽器會顯示 broken image，但不會導致建置錯誤
  return getSocialIconUrl(socialItem.icon_type)
}

const addClipboardListener = () => {
  clipboard.value = new ClipboardJS('.clipboard-social-media')
  clipboard.value.on('success', (e) => {
    $toast.info(t('common.copied'))
    e.clearSelection()
  })
  clipboard.value.on('error', (e) => {
    console.error('Action:', e.action)
    console.error('Trigger:', e.trigger)
  })
}

onMounted(() => {
  addClipboardListener()
})

onBeforeUnmount(() => {
  if (clipboard.value) {
    clipboard.value.destroy()
  }
})
</script>
<style scoped>
@reference "@/assets/css/tailwind.css";

.social-media-list > * {
  @apply w-7.5 h-7.5 xl:w-9 xl:h-9 6xl:w-[90px] 6xl:h-[90px] portrait:w-12 portrait:h-12;
}
</style>
